import request from '@/router/axios';

/**
 * 新建课堂分组
 * @param {Object} data 
 */
export const addGroup = (data) => {
    return request('/api/lab/group', { data }, 'post');
};

/**
 * 批量删除
 * @param {Array} data
 */
export const deleteGroups = data => {
    return request('/api/lab/group/deleteBatchByUid', { data }, 'delete');
};

/**
 * 分页查询课堂分组列表
 * @param {Number} page 当前页码
 * @param {Number} limit 每页条数
 * @param {*} params 其他参数
 * @param {String} params.lessonUid 课堂uid
 * 
 */
export const queryGroupList = (page, limit, params) => {
    return request('/api/lab/group/query', {
        params: {
            ...params,
            page,
            limit
        }
    });
};

/**
 * 获取分组详情
 * @param {String} uid 分组uid
 */
export const getGroupDetail = (uid) => {
    return request(`/api/lab/group/${uid}/detail`);
};

/**
 * 查询分组下未进小组的成员列表
 */
export const getNoGroupList = (uid) => {
    return request(`/api/lab/group/${uid}/noGroup/members`);
};
